module.exports = __webpack_public_path__ + "static/about_services01-1f131816765a4eaecf5ec16dcae7a14b.png";